import React from 'react';
import { View } from 'react-native';

import { cn } from '../utils/cn';

interface ProgressBarProps {
  strength: number; // 0-100
  hasError: boolean;
  testID?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ strength, hasError, testID }) => {
  return (
    <View className='h-2 w-full bg-login-gray-10 rounded overflow-hidden mt-2' testID={testID}>
      <View
        className={cn('h-full rounded', hasError ? 'bg-login-gold-50' : 'bg-login-green-50')}
        style={{ width: `${strength}%` }}
      />
    </View>
  );
};
